import { render, staticRenderFns } from "./BasketballParamsView.vue?vue&type=template&id=03e90044"
import script from "./BasketballParamsView.vue?vue&type=script&lang=js"
export * from "./BasketballParamsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports